import type { OrganizationWeekPlannerLocales } from '../types';

const organizationWeekPlannerLocales: OrganizationWeekPlannerLocales = {
  addAssignment: 'New Assignment',
  alertInterestJobNoLongerAssigned48HrsMessage:
    'This interest job starts within 48 hours, but there is no freelancer assigned (anymore). this job is no longer visible for freelancers. Convert it to an urgent job!',
  alertInterestShownWithoutAssignedFreelancerMessage:
    'A freelancer has shown interest in this job. You can assign someone!',
  alertPersonalJobStartsTomorrowNotAcceptedMessage:
    'This job starts tomorrow, but the freelancer has not accepted yet!',
  areYouSureYouWantToContinue: 'Are you sure you want to continue?',
  assignmentDate: 'Assignment Date',
  assignments: 'Assignments',
  assignmentType: 'Assignment Type',
  cancelBulkDialogMessage:
    'If you cancelled those assignments, you cannot undo it. Use the field to send a message to the freelancers about the reason for cancellation.',
  cancelDialogMessage:
    'If you cancelled this assignment, you cannot undo it. Use the field to send a message to the freelancer about the reason for cancellation.',
  cancelJob: 'Cancel job',
  compensateMessage:
    'This cancellation is within 24 hours before the start of the service. That means there is a $100 compensation for the freelancer who is scheduled.',
  contractRequestMsg: 'NB: You can only request contracts three times per day.',
  contractRequestSuccess:
    'We are processing your request, you will receive an email containing the requested contracts',
  contracts: 'Contracts',
  contractsExport: 'Contracts export',
  date: 'Date',
  endDate: 'End date',
  explanation: 'Explanation',
  explanationOfAbsence: 'Explanation of absence',
  exportContracts: 'Export contracts',
  feedbackDialogBodyMessage:
    'On %{date}, %{freelancer} ran a service for you. What did you think of the collaboration?',
  feedbackDialogBodyTitle: 'What did you think of %{freelancer}',
  feedbackDialogHeaderTitle: 'Rate Freelancer',
  filters: 'Filters',
  freelancerName: 'freelancer name',
  goBack: 'Go back',
  grid: 'Grid',
  importFromSDB: 'import from SDB',
  jobBulkCancel: {
    one: 'Cancel job',
    other: 'Cancel jobs',
  },
  jobPopoverAgreement: 'Agreement',
  // jobPopoverAssignFreelancer: 'Assign Freelancer',
  jobPopoverAssignmentDetails: 'Assignment Details',
  jobPopoverBlockFreelancerFromOrganization: 'Block Freelancer (organisation)',
  jobPopoverBlockFreelancerInLocation: 'Block Freelancer (location)',
  jobPopoverCancelAssignment: 'Cancel Assignment',
  jobPopoverConfirm: 'Confirm',
  jobPopoverConvertToUrgent: 'Convert to urgent',
  jobPopoverEdit: 'Edit',
  jobPopoverFavoriteFreelancerForLocation: 'Favorite freelancer (location)',
  jobPopoverFavoriteFreelancerForOrganization:
    'Favorite freelancer (organisation)',
  jobPopoverFeedback: 'Feedback',
  jobPopoverHours: 'Hours',
  jobPopoverNoShow: 'No show',
  jobPopoverRepeatAssignment: 'Repeat Assignment',
  jobPopoverSplit: 'Split (Morning/Afternoon)',
  jobPopoverUnblockFreelancerFromOrganization:
    'Unblock Freelancer (organisation)',
  jobPopoverUnblockFreelancerInLocation: 'Unblock Freelancer (location)',
  jobPopoverUnfavoriteFreelancerForLocation: 'Unfavorite freelancer (location)',
  jobPopoverUnfavoriteFreelancerForOrganization:
    'Unfavorite freelancer (organisation)',
  jobStatus: 'Job Status',
  jobStatusAssigned: 'Assigned',
  jobStatusOpen: 'Open',
  jobType: 'Job Type',
  jobTypeInterest: 'Interest',
  jobTypePersonal: 'Personal',
  JobTypeReplacement: 'Urgent',
  lateCancellationCompensation: 'Late Cancellation Compensation',
  location: 'Location',
  locations: 'Locations',
  maxMessageLengthErrorMessage: {
    one: 'max length: %{count} character',
    other: 'max length: %{count} characters',
  },
  minMessageLengthErrorMessage: {
    one: 'min length: %{count} character',
    other: 'min length: %{count} characters',
  },
  noResultsTable:
    'We were unable to find any results for you. Change the filters or contact Tadaah support.',
  noResultsTableTitle: 'No jobs found',
  noshowDialogMessage:
    "In the event of freelancer's absence, you can report this here. Use the field to explain the absence.",
  personenregisterAlertMessage:
    'Soon pedagogical employees will come to work for you, who according to our administration are not yet linked to the register of persons. See who it is here.',
  personRegister: 'Person register',
  personRegisterTooltip:
    'Click here for the Person Register Check Help to see whether pedagogical employees are scheduled who, according to our administration, are not yet linked to the persons register.',
  planner: 'Planner',
  ratingCannotBeEmpty: 'Rating cannot be empty',
  reasonOfCanceling: 'Reason of canceling',
  ReportAbsence: 'Report absence',
  requestContracts: 'Request contracts',
  ResetFilters: 'Reset filters',
  searchBoxPlaceholder: 'Search assignment/freelancer',
  searchDates: 'Select Dates',
  searchFreelancer: 'Search Freelancer',
  searchLocation: 'Search Location',
  searchOrganisation: 'Search Organisation',
  selectedJobs: {
    one: '%{count} selected job',
    other: '%{count} selected jobs',
  },
  selectEndDate: 'Select end date',
  selectFreelancer: 'Select Freelancer',
  selectLocation: 'Select Location',
  selectOrganization: 'Select Organization',
  selectStartDate: 'Select start date',
  sendFeedback: 'Send feedback',
  startDate: 'Start date',
  table: 'Table',
  thisIsIntrestAssignment: 'This is an interest job',
  thisIsPersonalAssignment: 'This is a personal job',
  thisIsUrgentAssignment: 'This is an urgent job',
  timeEndTime: 'Time/end time',
  yesCancelJob: 'Yes, cancel job',
  yesReportAbsence: 'Yes, report absence',
};

export default organizationWeekPlannerLocales;
